package com.bikompanion.domain.analytics

private val WordBoundary = Regex("([a-z0-9])([A-Z])")

/**
 * The enum's name in snake case, so reported values read like the event and parameter names.
 *
 * Derived rather than mapped by hand so a new constant reports without anyone remembering to add
 * it. Renaming a constant does change what is reported.
 */
fun Enum<*>.analyticsValue(): String = name.replace(WordBoundary, "$1_$2").lowercase()

fun Boolean.analyticsValue(): Long = if (this) 1L else 0L
